import React from 'react';
import { X, AlertCircle } from 'lucide-react';

const ErrorAlert = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div className="fixed top-4 right-4 max-w-md z-50 animate-fade-in">
      <div className="bg-white border border-red-200 rounded-xl shadow-2xl overflow-hidden">
        <div className="bg-gradient-to-r from-red-50 to-red-100 px-4 py-3 border-b border-red-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center">
                <AlertCircle className="w-5 h-5 text-red-500" />
              </div>
              <h4 className="text-sm font-semibold text-red-800">Error</h4>
            </div>
            {onClose && (
              <button
                onClick={onClose}
                className="p-1 text-red-600 hover:text-red-800 hover:bg-red-200 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-red-300"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
        <div className="px-4 py-3">
          <p className="text-sm text-gray-700 leading-relaxed">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorAlert;